import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  consultClientFatca: {},
  updateFatca: {},
};

export const fatcaSlice = createSlice({
  name: 'fatca',
  initialState,
  reducers: {

    // Consult Fatca Client

    setConsultClientFatcaLoading: (state) => {
      state.consultClientFatca = {
        isLoading: true,
      };
    },

    setConsultClientFatcaSuccess: (state, action) => {
      state.consultClientFatca = {
        data: action.payload
      };
    },

    setConsultClientFatcaFailure: (state, action) => {
      state.consultClientFatca = {
        error: action.payload,
      }
    },

    // Update Fatca

    setUpdateFatcaLoading: (state) => {
      state.updateFatca = {
        isLoading: true,
      };
    },

    setUpdateFatcaSuccess: (state) => {
      state.updateFatca = {
        success: true
      };
    },

    setUpdateFatcaFailure: (state, action) => {
      state.updateFatca = {
        error: action.payload,
      }
    },

    clearUpdateFatca: (state) => {
      state.updateFatca = {}
    },

  },
})

export const {
  setConsultClientFatcaLoading, setConsultClientFatcaSuccess, setConsultClientFatcaFailure,
  setUpdateFatcaLoading, setUpdateFatcaSuccess, setUpdateFatcaFailure, clearUpdateFatca,
} = fatcaSlice.actions

export default fatcaSlice.reducer;